const API_URL = 'https://karenscore-backend.karenscore.workers.dev/api';
const PROJECT_ID = 'e4ea2580-0064-4446-b762-cccc32c9c285';

async function handleResponse(res: Response) {
  if (!res.ok) {
    let errorMessage = res.statusText;
    try {
      const text = await res.text();
      if (text) {
        try {
          const json = JSON.parse(text);
          errorMessage = json.error || json.message || text;
          
          if (errorMessage === 'UPGRADE_REQUIRED') {
            window.dispatchEvent(new CustomEvent('karenscore:upgrade-required'));
          }
        } catch {
          errorMessage = text;
        }
      }
    } catch {
      // ignore
    }
    throw new Error(`API Error: ${res.status} ${errorMessage}`);
  }
  return res.json();
}

function getAuthHeader() {
  const headers: Record<string, string> = {
    'X-Project-Id': PROJECT_ID
  };
  try {
    const storage = localStorage.getItem('auth-storage');
    if (storage) {
      const { state } = JSON.parse(storage);
      if (state?.user?.encrypted_yw_id) {
        headers['X-Encrypted-Yw-ID'] = state.user.encrypted_yw_id;
      }
    }
  } catch (e) {
    // ignore
  }
  return headers;
}
export const api = {
  async get(endpoint: string) {
    const res = await fetch(`${API_URL}${endpoint}`, {
      headers: {
        ...(await getAuthHeader()),
      },
    });
    return handleResponse(res);
  },

  async post(endpoint: string, data: any = {}) {
    const res = await fetch(`${API_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(await getAuthHeader()),
      },
      body: JSON.stringify(data),
    });
    return handleResponse(res);
  },

  async put(endpoint: string, data: any = {}) {
    const res = await fetch(`${API_URL}${endpoint}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...(await getAuthHeader()),
      },
      body: JSON.stringify(data),
    });
    return handleResponse(res);
  },

  async delete(endpoint: string) {
    const res = await fetch(`${API_URL}${endpoint}`, {
      method: 'DELETE',
      headers: {
        ...(await getAuthHeader()),
      },
    });
    return handleResponse(res);
  },

  async getProfileMe() {
    return this.get('/profile/me');
  },
};

